import { useDispatch } from 'react-redux';
import React, { useCallback, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';

import { saveOrEditBatchNoteRequest } from '../../../store/batches/notes/batch-note.actions';

import style from './batch-note.module.less';

const EditBatchNote = ({ note, batchId, name, assignedToGuid, handleShowEditNoteInput = noop }) => {
  const dispatch = useDispatch();
  const node = useRef();
  const textArea = useRef();
  const [noteValue, setNoteValue] = useState(note);

  const onSaveBatchNote = useCallback(() => {
    dispatch(saveOrEditBatchNoteRequest(batchId, name, noteValue, assignedToGuid));
  }, [dispatch, batchId, name, noteValue, assignedToGuid]);

  const onChange = useCallback(
    (event) => {
      setNoteValue(event.target.value);
    },
    [setNoteValue],
  );

  const handleClickOutsideInputField = useCallback(() => {
    onSaveBatchNote();
    handleShowEditNoteInput();
  }, [onSaveBatchNote, handleShowEditNoteInput]);

  const checkForEnterPress = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        onSaveBatchNote();
        handleShowEditNoteInput();
      }
    },
    [onSaveBatchNote, handleShowEditNoteInput],
  );

  useEffect(() => {
    if (textArea.current) {
      textArea.current.focus();
      textArea.current.select();
    }
  }, []);

  return (
    <div ref={node} className={style['note-input']}>
      <textarea
        ref={textArea}
        className={style['edit-text-area']}
        maxLength={150}
        onBlur={handleClickOutsideInputField}
        onChange={onChange}
        onKeyDown={checkForEnterPress}
        value={noteValue}
      />
    </div>
  );
};

EditBatchNote.propTypes = {
  handleShowEditNoteInput: PropTypes.func,
  batchId: PropTypes.string,
  note: PropTypes.string,
  name: PropTypes.string,
  assignedToGuid: PropTypes.string,
};

export default EditBatchNote;
